import React from 'react';

interface IProteinIngredientsTemplateProps {
  width?: string;
}

export const ProteinIngredientsTemplate = (props: IProteinIngredientsTemplateProps) => {
  const { width = '17%' } = props;

  return (
    <div
      className={`w-[${width}] h-[100%] text-[0.875rem] text-[#1B1B1B] place-content-center`}
    >
      <a
        className="text-[#006AF5] underline"
        href="/assets/import files/ProteinIngredientsTemplate.txt"
        download="Protein Template.txt"
        title="Download Protein Ingredients Template"
      >
        Download Protein Template
      </a>
    </div>
  );
};
